import React from 'react';
import { cn } from '../../lib/utils';

const STYLES = {
  active:
    'bg-emerald-600/90 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] ring-1 ring-white/40',
  inactive:
    'bg-slate-500 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.28)] ring-1 ring-white/35',
  pending:
    'bg-amber-600 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.3)] ring-1 ring-white/40',
  complete:
    'bg-sky-600/90 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] ring-1 ring-white/40',
  viewing:
    'bg-[var(--brand-primary,#1A428A)] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.3)] ring-1 ring-white/40',
};

const LABELS = {
  active: 'Active',
  inactive: 'Inactive',
  pending: 'Pending',
  complete: 'Complete',
  viewing: 'Viewing',
};

export function AccountStatusBadge({ status, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[8px] font-semibold uppercase tracking-[0.1em]',
        STYLES[status] || STYLES.inactive,
        className
      )}
    >
      {LABELS[status] || status}
    </span>
  );
}
